enum OrganizationCountryCodes {
  UnitedStates = 'USA',
  Canada = 'CAN',
  International = 'INT',
}

export default OrganizationCountryCodes;
